export default "__VITE_ASSET__CZ7eqzQ0__"